<template>
  <div class="abilityNew">
    <div class="newImageArea">
      <img src="../assets/images/picture_17.png" alt="">
      <div class="imgLeft">
        <div>
          <img src="../assets/images/brief_picture_ruanshili.png" alt="">
        </div>
        <div class="abilityNewTitle fz24">代理人新模式</div>
        <div class="c666">每一位壹心保代的代理人，都是一个独立品牌。中立客观的身份、市场领先的专业、丰富多元的产品、贴心多维的服务，在充分发挥保险代理人价值的同时，壹心保代以「合伙人」和「事务所」模式成就更多代理人的事业梦想。我们注重专业品质提升、服务多元化体验、市场资源整合、以及个人品牌的打造。</div>
      </div>
    </div>
    <div class="bottom-img">
      <img src="../assets/images/picture_18.png" alt="">
    </div>

  </div>
</template>

<script>
  export default {
    name: 'abilityNew',
    components: {},
    data() {
      return {
      }
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .abilityNew {
    width: 1024px;
    margin: 0 auto;
    &>div {
      img {
        width: 100%;
      }
    }
    .bottom-img{
      width: 864px;
      margin: 40px auto;
    }
    .newImageArea{
      position: relative;
      .imgLeft{
        width: 390px;
        position: absolute;
        left: 70px;
        top: 30px;
        img{
          width: 80px;
        }
        .abilityNewTitle{
          margin: 40px 0 16px;
        }
        .c666{
          line-height: 26px;
        }
      }
    }
  }
</style>